module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/is-pure.js
// module id = 125
// module chunks = 0